import * as React from 'react';

import styles from './metric-error-state.module.css';

export class MetricErrorState extends React.Component {
    render() {
        return (
            <div className={styles.container}>
                <div className={styles['empty-row']} />
                <div className={styles['empty-row']} />
                <div className={styles['error-image-container']}>
                    <img
                        src='/include/images/dashboard/metrics-empty_2x.png'
                        className={styles['error-image']}
                    />
                </div>
                <div className={styles['error-text']}>
                    <span>We couldn’t load these metrics</span>
                </div>
            </div>
        );
    }
}
